import { SpecialistCardGridSkeleton, SpecialistCardIframe } from "@/components";
import { selectFilteredSpecialists } from "@/store/selectors";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

const SpecialistsListIframe: React.FC<{ isLoading: boolean }> = ({ isLoading }) => {
  const specialists = useSelector(selectFilteredSpecialists);
  const { lang } = useParams<{ lang?: string }>();

  const handleCardClick = (slug: string) => {
    let targetUrl = import.meta.env.VITE_IFRAME_TARGET_URL;

    if (lang) {
      targetUrl += `/${lang}`;
    }

    targetUrl += `/our-specialists/${slug}/`;
    if (window.top) {
      window.top.location.href = targetUrl;
    }
  };

  return (
    <div className="m-4 grid w-full grid-cols-1 gap-1 gap-x-1 gap-y-8 sm:grid-cols-2 md:grid-cols-4 xl:grid-cols-5">
      {isLoading && (
        <>
          {Array.from({ length: 8 }).map((_, index) => (
            <SpecialistCardGridSkeleton key={index} />
          ))}
        </>
      )}
      {specialists?.map((specialist) => (
        <SpecialistCardIframe
          specialist={specialist}
          key={specialist.id}
          onClick={() => handleCardClick(specialist.slug)}
        />
      ))}
    </div>
  );
};

export { SpecialistsListIframe };
